// One club structure for desktop, mobile and old deep links. No membership fallback.
export const clubSections = [
  { id: 'overview', path: '/dashboard', label: ['Översikt', 'Overview'] },
  { id: 'identity', path: '/dashboard?view=identity', label: ['Sportslig riktning', 'Sporting direction'] },
  { id: 'teams', path: '/teams', label: ['Lag', 'Teams'] },
  { id: 'planning', path: '/dashboard?view=planning', label: ['Gemensamma mallar', 'Shared templates'] },
  { id: 'administration', path: '/members', label: ['Administration', 'Administration'] },
];

export function clubSectionForLocation(pathname, search = '') {
  if (!/^\/org\/[^/]+(?:\/|$)/.test(pathname)) return null;
  const page = pathname.split('/')[3] || 'dashboard';
  if (page === 'teams') return ['manage','create'].includes(new URLSearchParams(search).get('view')) && !new URLSearchParams(search).get('team') ? 'administration' : 'teams';
  if (page === 'members') return 'administration';
  if (page === 'roles') return 'administration';
  if (page !== 'dashboard' && page !== '') return null;
  const view = new URLSearchParams(search).get('view');
  if (['identity', 'identity-teams', 'sports-plan', 'yearwheel'].includes(view)) return 'identity';
  if (['development', 'followups', 'evaluations'].includes(view)) return 'overview';
  if (['planning', 'club-exercises', 'briefing-templates', 'templates', 'evaluation-templates'].includes(view)) return 'planning';
  if (view === 'administration') return 'administration';
  return 'overview';
}

export function clubSectionHref(orgId, section) {
  const aliases = {people: '/members', development: '/dashboard?view=development'};
  if(aliases[section])return `/org/${encodeURIComponent(orgId)}${aliases[section]}`;
  const entry = clubSections.find(item => item.id === section);
  return entry ? `/org/${encodeURIComponent(orgId)}${entry.path}` : null;
}
